import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./CourseCategory.css";

import javaImg from "../assets/java.jpeg";
import pythonImg from "../assets/python.jpg";
import mernImg from "../assets/Mern.png";
import uiuxImg from "../assets/uiux.jpg";
import datascienceImg from "../assets/datascience.jpg";
import aimlImg from "../assets/aiml.jpg";
import cloudImg from "../assets/cloud.jpeg";
import dsaImg from "../assets/dsa.jpg";
import appImg from "../assets/appdevelopment.png";
import cybersecurityImg from "../assets/cs.png";
import digitalmarketingImg from "../assets/digitalmarketing.jpeg";
import dataanalyticsImg from "../assets/dataanalytics.jpeg";
import autocadImg from "../assets/Autocad.jpg";
import financeImg from "../assets/Finance.jpg";
import interviewtrainingImg from "../assets/TrainingandPlacement.jpg";
import businessanalyticscourseImg from "../assets/businessanalyticscourse.png";
import humanresourcescourseImg from "../assets/humanresourcescourse.jpg";

function CourseCategory() {
  const { category } = useParams();
  const navigate = useNavigate();

  const technicalCourses = [
    { slug: "java", title: "Java Full Stack", img: javaImg },
    { slug: "python", title: "Python Full Stack", img: pythonImg },
    { slug: "mern", title: "MERN Development", img: mernImg },
    { slug: "uiux", title: "UI/UX Design", img: uiuxImg },
    { slug: "datascience", title: "Data Science", img: datascienceImg },
    { slug: "aiml", title: "AI & ML", img: aimlImg },
    { slug: "cloudcomputing", title: "Cloud Computing", img: cloudImg },
    { slug: "dsa", title: "DSA", img: dsaImg },
    { slug: "appdevelopment", title: "App Development", img: appImg },
    { slug: "cybersecurity", title: "Cyber Security", img: cybersecurityImg },
    { slug: "dataanalytics", title: "Data Analytics", img: dataanalyticsImg },
    { slug: "autocad", title: "AutoCAD", img: autocadImg },
  ];

  const managementCourses = [
    { slug: "digitalmarketing", title: "Digital Marketing", img: digitalmarketingImg },
    { slug: "businessanalytics", title: "Business Analytics", img: businessanalyticscourseImg },
    { slug: "humanresource", title: "Human Resource", img: humanresourcescourseImg },
    { slug: "finance", title: "Finance", img: financeImg },
  ];

  const interviewtraining = [
    { slug: "trainingandplacement", title: "Training & Placement", img: interviewtrainingImg },
  ];

  const data =
    category === "technical"
      ? technicalCourses
      : category === "management"
      ? managementCourses
      : interviewtraining;

  return (
    <div className="courses-section py-5">
      <Container>
        <h1 className="courses-title text-center mb-3">
          {category === "technical"
            ? "Technical Courses"
            : category === "management"
            ? "Management Courses"
            : "Training & Placement Courses"}
        </h1>

        <Row>
          {data.map((course, index) => (
            <Col md={4} sm={6} xs={12} key={index} className="mb-4">
              <Card
                className="course-card shadow-sm border-0 h-100"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/course/${course.slug}`)}
              >
                <Card.Img
                  variant="top"
                  src={course.img}
                  className="course-img"
                />
                <Card.Body>
                  <Card.Title>{course.title}</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default CourseCategory;
